import { useMemo } from 'react'
import { BigNumber } from 'ethers'
import { bn, e2w } from '../../utils/number'
import { usePerpOpenOrders } from '../../store/perp/hooks'

export function useTotalFrozenMargin(): BigNumber {
  const openOrders = usePerpOpenOrders()

  return useMemo(() => {
    if (!openOrders || !openOrders?.length) return bn(0)
    return openOrders.reduce((prev, current): BigNumber => {
      return prev.add(e2w(current.frozenMargin))
    }, bn(0))
  }, [openOrders])
}
